module.exports = __webpack_public_path__ + "img/notification.525d4777.svg";